import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthCoreService } from './auth-core.service';
import { ApiModule } from '../api/api.module';

@NgModule({
  declarations: [],
  imports: [CommonModule, ApiModule],
  providers: [AuthCoreService],
})
export class AuthCoreModule {}
